import React from 'react'
import { AdminDashboard } from '../../components/AdminDashboard'
import { withUser } from '../../components/withUser'
import AdminLayout from '../../components/AdminLayout'

const AdminIndex: React.FC = () => (
  <AdminLayout>
    <AdminDashboard />
  </AdminLayout>
)

export default withUser(AdminIndex)
